import { AnalyticsEventName } from './constants';
import { AuthContextProps } from 'react-oidc-context';
import { trackEvent } from './utils';
import { UserProfile } from 'oidc-client-ts';
import { waitForEvent } from './analyticsUtils';

export const getMemberType = (auth: AuthContextProps, isPm: boolean, isIm: boolean) => {
  const userProfile = auth.user?.profile;

  if (!userProfile || Object.keys(userProfile || {}).length === 0 || !auth.isAuthenticated) {
    return 'Anon';
  }

  if (userProfile.sub === '0') {
    return 'Non-Member';
  }
  if (isIm) {
    return 'Individual Member';
  }
  if (isPm) {
    return 'Privileged Member';
  }

  return 'Member';
};

export const getAccountType = (isPm: boolean, isIm: boolean, userProfile?: UserProfile): string => {
  if (!userProfile) {
    return 'Regular';
  }
  return isIm
    ? 'IM'
    : isPm
      ? 'PM'
      : ['LMSAdmin'].find(
          type => (userProfile?.[`Is${type}`] as string)?.toLowerCase() === 'true'
        ) || 'Regular';
};

export const trackSetUserInfoEvent = (
  auth: AuthContextProps,
  isPm: boolean,
  isIm: boolean,
  persona: string | null = null
) => {
  const userProfile = auth.user?.profile;

  trackEvent({
    eventName: AnalyticsEventName.SetUserInfo,
    parameters: {
      userId: userProfile?.sub ?? null,
      membership: isPm || isIm,
      memberType: getMemberType(auth, isPm, isIm),
      organizationId: userProfile?.OrganizationSK ?? null,
      persona: persona,
      source: 'frontend.pli.edu'
    }
  });
};

export const trackAccountLoginEvent = (isPm: boolean, isIm: boolean, userProfile?: UserProfile) => {
  const accountType = getAccountType(isPm, isIm, userProfile);
  return waitForEvent(() =>
    trackEvent({
      eventName: AnalyticsEventName.Login,
      parameters: { accountType }
    })
  );
};

export const trackPliPromoEvent = (tcode?: string | null) => {
  if (tcode) {
    trackEvent({
      eventName: AnalyticsEventName.PliPromo,
      parameters: { tcode: tcode }
    });
  }
};
